
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './components/theme-provider';
import Auth from './pages/Auth';
import Home from './pages/Home';
import Upload from './pages/Upload';
import TeamDetails from './pages/TeamDetails';
import HeadToHead from './pages/HeadToHead';
import DataTablePage from './pages/DataTablePage';
import CountryOrder from './pages/CountryOrder';
import Compare from './pages/Compare';
import Football from './pages/Football';
import Results from './pages/Results';
import OddsAnalysis from './pages/OddsAnalysis';
import { Toaster } from './components/ui/toaster';
import './App.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/team/:teamName" element={<TeamDetails />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/compare/:team1/:team2" element={<Compare />} />
              <Route path="/data-table" element={<DataTablePage />} />
              <Route path="/country-order" element={<CountryOrder />} />
              <Route path="/head-to-head" element={<HeadToHead />} />
              <Route path="/football" element={<Football />} />
              <Route path="/results" element={<Results />} />
              <Route path="/odds-analysis" element={<OddsAnalysis />} />
            </Routes>
            <Toaster />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
